import { create } from 'zustand';

interface Workspace {
  id: string;
  name: string;
  slug: string;
  role: string;
  settings?: Record<string, any>;
  isSuperAdminAccess?: boolean;
  owner?: { id: string; email: string; name: string | null } | null;
}

interface WorkspaceState {
  currentWorkspace: Workspace | null;
  workspaces: Workspace[];
  setCurrentWorkspace: (workspace: Workspace) => void;
  setWorkspaces: (workspaces: Workspace[]) => void;
}

export const useWorkspaceStore = create<WorkspaceState>((set) => ({
  currentWorkspace: null,
  workspaces: [],
  setCurrentWorkspace: (workspace) => set({ currentWorkspace: workspace }),
  setWorkspaces: (workspaces) => set({ workspaces }),
}));
